<template>
  <div class="z-navbar">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between">
            <a href="https://zeyplay.com">
              <img
                class="logo"
                src="/img/logo.svg"
                alt=""
              >
            </a>

            <el-dropdown
              v-if="isLogged"
              trigger="click"
            >
              <div class="user">
                <img
                  v-if="user.avatar"
                  :src="user.avatar"
                  alt=""
                  class="user__avatar"
                >
                <div
                  v-else
                  class="no-avatar"
                >
                  <i class="icon icon-user" />
                </div>
                <span class="user__name">
                  {{ user.name }}
                </span>
              </div>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="logout">
                  Logout
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ZNavbar',

  data: () => ({
    showMobileMenu: false,
  }),

  computed: {
    isLogged() {
      return this.$store.getters.isLogged;
    },
    user() {
      return this.$store.getters.user;
    },
  },

  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
  },
};
</script>

<style lang="scss" scoped>
.z-navbar {
  display: flex;
  align-items: center;
  height: 70px;
  width: 100%;
  background: var(--color-blue-100);
}

.logo {
  height: 65px;
}

.nav {
  margin-right: auto;
  margin-left: 60px;
}

a {
  color: var(--color-white);
  font-family: var(--font-bold);
  font-size: 14px;
  transition: 0.2s;

  &:hover {
    cursor: pointer;
    text-decoration: none;
    color: var(--color-secondary);
  }
}

ul {
  padding: 0;
  margin: 0;
}

li {
  list-style: none;
  margin-right: 40px;

  &:last-of-type {
    margin-right: 0;
  }
}

.private-wrapper {
  display: flex;
  align-items: center;
  text-transform: uppercase;
}

.wallet {
  height: 50px;
  padding: 0 25px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: var(--font-medium);
  border-radius: 10px;
  transition: 0.2s;

  .icon {
    position: relative;
    top: 1px;
    color: var(--color-secondary);
    font-size: 17px;
    margin-right: 10px;
  }
}

.user {
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  transition: 0.2s;
  border-radius: 10px;
  color: var(--color-white);

  &:hover {
    background: #1c232c;
    cursor: pointer;
  }

  &__avatar {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-right: 10px;
  }

  .no-avatar {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-right: 10px;
    background: var(--color-blue-300);
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      color: var(--color-blue-100);
    }
  }

  &__name {
    font-size: 14px;
    font-family: var(--font-bold);
  }
}

@media screen and (max-width: 991px) {
  .z-navbar {
    height: 50px;
  }

  .logo {
    position: relative;
    top: -1px;
    height: 50px;
  }
}
</style>
